import { SelectHTMLAttributes } from 'react';

import { Container } from './styles';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  value: any;
  options: Array<{
    value: string;
    label: string;
  }>;
}

export const Select = ({ name, value, options, ...rest }: SelectProps) => {
  return (
    <Container className="select-block">
      <select value={value} id={name} {...rest}>
        {options.map((option) => {
          return (
            <option key={option.value} value={option.label}>
              {option.label}
            </option>
          );
        })}
      </select>
    </Container>
  );
};
